import React from 'react';
import PageHeader from '../components/PageHeader';
import SessionRequestForm from '../components/SessionRequestForm';
import usePageMeta from '../hooks/usePageMeta';

const SessionRequest = () => {
  usePageMeta({
    title: 'Session Request — Book a Seattle Spanking / OTK Session',
    description: 'Request a confidential spanking session with RealOTK in Seattle, Tacoma, Everett, Bellevue, or Western Washington. OTK, paddling, whipping, and cane discipline. First session always free.',
    path: '/session-request',
  });
  return (
  <div>
    <PageHeader
      eyebrow="Confidential Inquiry"
      title="Session Request"
      subtitle="Real spankings for real reasons. First sessions are always free."
      image="https://images.unsplash.com/photo-1613491291185-eab390ed50eb?ixid=M3wzOTE5Mjl8MHwxfHNlYXJjaHwzfHxpbXByb3ZlbWVudHxlbnwwfHx8fDE3MTMyODkxMjN8MA&ixlib=rb-4.0.3&auto=format&fit=crop&w=3840"
    />
    <section className="bg-neutral-50">
      <div className="max-w-3xl mx-auto px-6 lg:px-10 py-20 md:py-28">
        <SessionRequestForm />
      </div>
    </section>
  </div>
  );
};

export default SessionRequest;
